import { AppAreaConfig } from '@/funnels/@types'
import walkingFemaleAl from './activity-female-walking-al'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f', 'age-tai-chi-walking-f'],
		route: {
			path: '/tai-chi-walking-f-al',
			name: 'tai-chi-walking-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-walking',
		route: {
			path: '/tai-chi-walking-f-al/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-tai-chi-walking-al',
		},
		slug: 'activity-female-tai-chi-walking-al',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: walkingFemaleAl,
				page: 'physical-build',
			},
		},
	},
}

export default appAreaConfig
